/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '*',
            redirect: "/404"
              // 아래처럼 바로 NotFound 경로를 매칭해도 됨
              // component: NotFound
        },
        /** 
         * 소스충돌방지를 위해 본사권한, 센터권한 나누어서 URL등록하시기 바랍니다.
         * 
         * 본사권한 START */
        {
            path: '/quickSetting',
            name: '환경설정',
            component: () => import('./views/SysManage/QuickSetting.vue')
        },
        {
            path: '/',
            name: 'main',
            component: () => import('./views/Main/main.vue')
        },
       
        {
            path: '/authMng',
            name: '권한관리',
            component: () => import('./views/SysManage/AuthMng.vue')
        },
        {
            path: '/pgmMng',
            name: '메뉴관리',
            component: () => import('./views/SysManage/PgmMng.vue')
        },
        {
            path: '/codeMng',
            name: '코드관리',
            component: () => 
                import ('./views/InfoManage/CodeMng.vue')
        },
        {
            path: '/catManager',
            name: '종합코드관리',
            component: () =>
                import ('./views/InfoManage/CatManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/configManager',
            name: '환경설정관리',
            component: () =>
                import ('./views/InfoManage/ConfigManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/deptManager',
            name: '부서관리',
            component: () =>
                import ('./views/InfoManage/DeptManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/programManager',
            name: '프로그램관리',
            component: () =>
                import ('./views/InfoManage/ProgramManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/groupManager',
            name: '그룹관리',
            component: () =>
                import ('./views/InfoManage/GroupManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/userManager',
            name: '유저관리',
            component: () =>
                import ('./views/InfoManage/UserManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/programAuthManager',
            name: '권한 관리',
            component: () =>
                import ('./views/InfoManage/ProgramAuthManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/productManager',
            name: '제품사양관리',
            component: () =>
                import ('./views/InfoManage/ProductManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/callCatManager',
            name: '상담분류관리',
            component: () =>
                import ('./views/InfoManage/CallCatManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/failureCauseManager',
            name: '고장원인관리',
            component: () =>
                import ('./views/InfoManage/failureCauseManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/repairCatManager',
            name: '장애처리관리',
            component: () =>
                import ('./views/InfoManage/repairCatManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/obstacleTreatManager',
            name: '장애처리기술료관리',
            component: () =>
                import ('./views/InfoManage/ObstacleTreatManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/siteManager',
            name: '사이트관리',
            component: () =>
                import ('./views/InfoManage/SiteManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/asChargeManager',
            name: '대행료관리',
            component: () =>
                import ('./views/InfoManage/AsChargeManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/dataUpload',
            name: '데이터업로드',
            component: () =>
                import ('./views/InfoManage/DataUpload.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/agentManager',
            name: '센터관리',
            component: () =>
                import ('./views/InfoManage/AgentManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/agentZoneManager',
            name: '센터관할지역관리',
            component: () =>
                import ('./views/InfoManage/AgentZoneManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/bomManager',
            name: 'BOM관리',
            component: () =>
                import ('./views/InfoManage/BomManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/zipManager',
            name: '우편번호관리',
            component: () =>
                import ('./views/InfoManage/ZipManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/materialsManager',
            name: '우편번호관리',
            component: () =>
                import ('./views/InfoManage/MaterialsManager.vue'),
            meta: { menuIdx: 3 }
        },
        {
            path: '/login',
            name: 'Login',
            props: true,
            component: () => 
                import ('./components/Login.vue'),
        },
        {
            path: '/oauth/new',
            name: 'OAuthNewUser',
            props: true,
            component: () => 
                import ('./components/OAuthNewUser.vue'),
        },
        {
            path: '/GridComponent',
            name: 'GridComponent',
            component: () => 
                import ('./views/GridComponent.vue'),
        },
        /* 콜센터 게시판 시작*/
        {
            path: '/DocList',
            name: 'DocList',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "일반공지사항",
                type: "Normal"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/TechDocList',
            name: 'TechDocList',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "기술공지사항",
                type: "Importance"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/BoardList',
            name: '게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "게시판",
                type: "Default"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/PraiseList',
            name: '칭찬게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "칭찬게시판",
                type: "Praise"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/QualitycertiList',
            name: '품질정보서게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                    title: "품질정보서게시판",
                    type: "Quality"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/ProductChangeList',
            name: '제품교환게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "제품교환게시판",
                type: "ProductChange"
            },
            meta: { menuIdx: 4 }
        },
        /* 콜센터 게시판 끝*/
        /* 센터 게시판 시작*/
        {
            path: '/aDocList',
            name: 'aDocList',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "일반공지사항",
                type: "Normal"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/aTechDocList',
            name: 'aTechDocList',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "기술공지사항",
                type: "Importance"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/aBoardList',
            name: '게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "게시판",
                type: "Default"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/aPraiseList',
            name: '칭찬게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "칭찬게시판",
                type: "Praise"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/aQualitycertiList',
            name: '품질정보서게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "품질정보서게시판",
                type: "Quality"
            },
            meta: { menuIdx: 4 }
        },
        {
            path: '/aProductChangeList',
            name: '제품교환게시판',
            component: () =>
                import ('./views/Bbs/DocList.vue'),
            props: {
                title: "제품교환게시판",
                type: "ProductChange"
            },
            meta: { menuIdx: 4 }
        },
        /* 센터 게시판 끝*/
        {
            path: '/listSaleSupportGuide',
            name: 'listSaleSupportGuide',
            component: () =>
                import ('./views/Bbs/List.vue'),
            props: {
                title: "판매지원",
                boardCd:"11" 
            }, 
        },
        {
            path: '/ListNewsletter',
            name: 'ListNewsletter',
            component: () =>
                import ('./views/Bbs/List.vue'),
            props: {
                title: "소식지",
                boardCd:"21" 
            }, 
        },
        {
            path: '/ListSuggest',
            name: 'ListSuggest',
            component: () =>
                import ('./views/Bbs/List.vue'),
            props: {
                title: "건의사항",
                boardCd:"22" 
            }, 
        },
        {
            path: '/boardWrite',
            name: 'boardWrite',
            props: true,
            component: () => import('./views/Bbs/Write.vue'),
        },
        {
            path: '/boardRead',
            name: 'boardRead',
            props: true,
            component: () => import('./views/Bbs/Read.vue'),
        },
        {
            path: '/boardMngRead',
            name: 'boardMngRead',
            props: true,
            component: () => import('./views/Bbs/DocRead.vue'),
        },
        //샘플 화면
        {
            path: '/sample',
            name: 'sample',
            component: () =>
                import ('./views/sample.vue'),
        },
        /* AS접수 > 접수관리*/
        {
            path: '/callMain',
            name: 'callMain',
            component: () =>
                import('./views/AsMng/index.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/callMain2',
            name: 'callMain2',
            component: () =>
                import('./views/AsMng/index.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/AsMngCallList',
            name: 'AS접수리스트',
            component: () =>
                import('./views/AsMng/AsMngCallList.vue')
        },
        {
            path: '/callDisposeList',
            name: 'AS처리리스트',
            component: () =>
                import('./views/WorkMng/CallDisposeList.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/approvalList',
            name: '승인처리리스트',
            component: () =>
                import('./views/WorkMng/ApprovalList.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/bsMaEdit',
            name: 'BS/MA등록',
            component: () =>
                import('./views/WorkMng/BsMaEdit.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/productInstallEdit',
            name: '제품설치등록',
            component: () =>
                import('./views/WorkMng/ProductInstallEdit.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/mateReEntering',
            name: '자재환입처리',
            component: () =>
                import('./views/WorkMng/MateReEntering.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/mateEntering',
            name: '자재입고처리',
            component: () =>
                import('./views/WorkMng/MateEntering.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/mateDelivery',
            name: '자재출고처리',
            component: () =>
                import('./views/WorkMng/MateDelivery.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/reqMateEnter',
            name: '요청자재출고',
            component: () =>
                import('./views/WorkMng/ReqMateEnter.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/productReEntering',
            name: '제품환입처리',
            component: () =>
                import('./views/WorkMng/ProductReEntering.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/productEntering',
            name: '제품출고처리',
            component: () =>
                import('./views/WorkMng/ProductEntering.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/mateStock',
            name: '자재현재고리스트',
            component: () =>
                import('./views/WorkMng/MateStock.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/productStock',
            name: '제품현재고리스트',
            component: () =>
                import('./views/WorkMng/ProductStock.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/calculationList',
            name: '정산관리',
            component: () =>
                import('./views/WorkMng/CalculationList.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/closingManager',
            name: '마감관리',
            component: () =>
                import('./views/WorkMng/ClosingManager.vue'),
            meta: { menuIdx: 1 }
        },
        {
            path: '/MateReturn',
            name: '자재반품리스트',
            component: () =>
                import('./views/WorkMng/MateReturn.vue')
        },
        {
            path: '/CallList',
            name: '상담접수리스트',
            component: () =>
                import('./views/AsMng/CallList.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/ArmyCallList',
            name: '군공접수리스트',
            component: () =>
                import('./views/AsMng/ArmyCallList.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/MateSaleList',
            name: '자재판매리스트',
            component: () =>
                import('./views/AsMng/MateSaleList.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/DeliveryList',
            name: '배송처리리스트',
            component: () =>
                import('./views/AsMng/DeliveryList.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappycallList',
            name: '해피콜리스트',
            component: () =>
                import('./views/AsMng/HappycallList.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappyCallManager',
            name: 'HappyCallManager',
            component: () =>
                import('./views/WorkMng/HappyCallManager.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappycallInfoTab',
            name: 'HappycallInfoTab',
            component: () =>
                import('./views/WorkMng/HappycallInfoTab.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappycallInfoTab2',
            name: 'HappycallInfoTab2',
            component: () =>
                import('./views/WorkMng/HappycallInfoTab.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappycallCustTab',
            name: 'HappycallCustTab',
            component: () =>
                import('./views/WorkMng/HappycallInfoTab.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/HappyCallDistribution',
            name: 'HappyCallDistribution',
            component: () =>
                import('./views/WorkMng/HappycallInfoTab.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/DailyReceivableManager',
            name: '일별수불부',
            component: () =>
                import('./views/WorkMng/DailyReceivableManager.vue'),
            meta: { menuIdx: 0 }
        },
        {
            path: '/AgentList',
            name: '센터정보조회',
            component: () =>
                import('./views/AsMng/AgentList.vue'),
            meta: { menuIdx: 0 }
        },

        /** 분석관리 START */

        {
            path: '/ServicePendency',
            name: '서비스미결현황',
            component: () =>
                import('./views/ReportMng/ServicePendency.vue')
        },
        {
            path: '/ServicePendencyD',
            name: '서비스미결상세현황',
            component: () =>
                import('./views/ReportMng/ServicePendencyD.vue')
        },
        {
            path: '/ServiceQuickness',
            name: '서비스처리(신속도)',
            component: () =>
                import('./views/ReportMng/ServiceQuickness.vue')
        },
        {
            path: '/ServicePromise',
            name: '서비스처리(약속방문적중율)',
            component: () =>
                import('./views/ReportMng/ServicePromise.vue')
        },
        {
            path: '/ServiceState',
            name: '서비스종합현황',
            component: () =>
                import('./views/ReportMng/ServiceState.vue')
        },
        {
            path: '/AsCause',
            name: '고장원인별현황',
            component: () =>
                import('./views/ReportMng/AsCause.vue')
        },
        {
            path: '/AsSymptoms',
            name: '고장증상별현황',
            component: () =>
                import('./views/ReportMng/AsSymptoms.vue')
        },
        {
            path: '/AgentCalculation',
            name: '센터별정산현황',
            component: () =>
                import('./views/ReportMng/AgentCalculation.vue')
        },
        {
            path: '/ItemCalculation',
            name: '제품군별정산현황',
            component: () =>
                import('./views/ReportMng/ItemCalculation.vue')
        },
        {
            path: '/SiteInstall',
            name: 'Site별설치비정산',
            component: () =>
                import('./views/ReportMng/SiteInstall.vue')
        },
        {
            path: '/AgentInstall',
            name: '센터별설치비정산',
            component: () =>
                import('./views/ReportMng/AgentInstall.vue')
        },


        /** 분석관리 END */
        

        /** 본사권한 END */

        /** 센터권한 START */
        {
            path: '/VisitCall',
            name: 'AS내근접수',
            component: () =>
                import('./views/Agent/VisitCall.vue')
        },
        {
            path: '/AsCallList',
            name: 'AS미처리리스트',
            component: () =>
                import('./views/Agent/AsCallList.vue')
        },
        {
            path: '/BsmaList',
            name: 'BS/MA처리리스트',
            component: () =>
                import('./views/Agent/BsmaList.vue')
        },
        {
            path: '/ReqMateList',
            name: '요청자재관리',
            component: () =>
                import('./views/Agent/ReqMateList.vue')
        },
        {
            path: '/MateEnterList',
            name: '자재입고관리',
            component: () =>
                import('./views/Agent/MateEnterList.vue')
        },
        {
            path: '/InstallList',
            name: '설치처리리스트',
            component: () =>
                import('./views/Agent/InstallList.vue')
        },
        {
            path: '/MateReturnList',
            name: '자재반품관리',
            component: () =>
                import('./views/Agent/MateReturnList.vue')
        },
        {
            path: '/AgentCalculationList',
            name: '정산리스트',
            component: () =>
                import('./views/WorkMng/AgentCalculationList.vue'),
            meta: { menuIdx: 1 }
        },

        {
            path: '/AgentStock',
            name: '재고현황',
            component: () =>
                import('./views/WorkMng/AgentStock.vue'),
            meta: { menuIdx: 1 }
        },

        {
            path: '/AgentMonthStock',
            name: '월별수불현황',
            component: () =>
                import('./views/WorkMng/AgentMonthStock.vue'),
            meta: { menuIdx: 1 }
        },

        {
            path: '/ServiceManManager',
            name: '기사정보관리',
            component: () =>
                import('./views/InfoManage/ServiceManManager.vue'),
            meta: { menuIdx: 1 }
        },

        {
            path: '/ScheduleManager',
            name: '스케줄관리',
            component: () =>
                import('./views/InfoManage/ScheduleManager.vue'),
            meta: { menuIdx: 1 }
        },


        /** 센터권한 END */

        
        /** 대행사권한 START */
        {
            path: '/AgencyReg',
            name: '대행사접수',
            component: () =>
                import('./views/Agent/VisitCall.vue')
        },


        /** 대행사권한 END */

        /** 일반사용자권한 START */
        {
            path: '/survey',
            name: 'Survey',
            props: true,
            component: () => 
                import ('./components/Survey.vue'),
        }
        /** 일반사용자권한 END */
    ],
});
